'use strict';

angular.module('admin.iframe')

.controller('IframeAdminCtrl', function ($scope, model, modelNameField)
{
    $scope.model = model;
    $scope.modelNameField = modelNameField;

    if ($scope.model.enabled === undefined){
        $scope.model.enabled = false;
    }

    $scope.saveModel = function ()
    {
        console.log('saveModel', $scope.model);
        $scope.model.DSCreate(model, {upsert: true}).then($scope.$close);
    };
});
